"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var KsysRequest_1 = require("../KsysRequest");

var ListFundLists =
/** @class */
function (_super) {
  __extends(ListFundLists, _super);

  function ListFundLists() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getExplicitEndpoint = function () {
      return '/config/listfundlists';
    };

    return _this;
  }

  Object.defineProperty(ListFundLists.prototype, "endpointConfiguration", {
    get: function get() {
      return this.getEndpointConfiguration("config", "ListFundLists");
    },
    enumerable: true,
    configurable: true
  });
  return ListFundLists;
}(KsysRequest_1.KsysRequest);

exports.ListFundLists = ListFundLists;